import DialogTextField from './DialogTextField';
import DialogDetailsField from './DialogDetailsField';

const ReadonlyFields = {
    Text: DialogTextField,
    Details: DialogDetailsField,
};
export default ReadonlyFields;